var ValueJS = ValueJS || {};

ValueJS.Typewriter = function() {

    var _defaults = {
        separator: '|'
    }

    var _init = function() {
        $('[data-typewriter]').each(function() {
            let el = $(this);
            new Typewriter(el[0], {
                loop: true,
                strings: el.data('typewriter').split(_defaults.separator),
                delay: 50,
                autoStart: true
            });
        })
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    ValueJS.Typewriter.init();
});